let consoleFlag = false;
let browserFlag = false;

// Console initializes its flag (ISO_FUSE5_STYLING)
export const initializeConsoleFuseFiveFeatureFlag = (value) => {
    consoleFlag = value;
};

// Browser initializes its flag (ISO_FUSE5_STYLING_BROWSER)
export const initializeBrowserFuseFiveFeatureFlag = (value) => {
    browserFlag = value;
};

// Console-only components use this
export const isFuse5Enabled = () => {
    return consoleFlag || browserFlag;
};

// Browser and shared components use this
// This ensures shared components wait for browser flag
export const isBrowserFuse5Enabled = () => {
    return browserFlag;
};
